import appConfig from '~/config/app'
import ArticleAuthor from '~/shared/components/Articles/ArticleAuthor/ArticleAuthor'
import TutorOnDemandProductCards from '~/shared/components/TutorOnDemandProductCards/TutorOnDemandProductCards.component'
import { BlockContent } from '~/components'
import { SanityImage } from '~/types/sanity'

import styles from '~/shared/components/Articles/Articles.module.css'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [
  { screen: '(max-width: 767px)', width: '80vw' },
  { screen: '(min-width: 768px)', width: '576px' },
]

export default function ArticleDetail({
  author,
  authorAvatar,
  content,
  enableTODProductCard = true,
  isTutorOnDemandArticle,
  landscapeImage,
  title,
  releaseDate,
}: {
  author?: string
  authorAvatar?: SanityImage
  content: unknown[]
  enableTODProductCard?: boolean
  isTutorOnDemandArticle?: boolean
  landscapeImage: SanityImage
  title: string
  releaseDate: string
}): React.ReactElement {
  return (
    <section>
      <article className="max-w-xl mx-auto text-black-light">
        <ArticleAuthor author={author} authorAvatar={authorAvatar} className="mb-4" releaseDate={releaseDate} />
        <h1 className="mb-2 text-h3 font-semibold leading-10">{title}</h1>

        <ResponsiveImage
          alt={landscapeImage.alt}
          height={260}
          imageClassName="mt-4 mb-8 rounded"
          imageWidths="576"
          loading="eager"
          mediaQuery={mediaQuery}
          srcKey={landscapeImage.srcKey}
          width={576}
        />

        <BlockContent blocks={content} className={styles.article} />
      </article>

      {isTutorOnDemandArticle && enableTODProductCard && !appConfig.isSchoolPlatform && (
        <div className="mt-20 max-w-max mx-auto">
          <TutorOnDemandProductCards
            className="space-y-14 lg:space-y-0 lg:space-x-4 xl:space-x-8 flex flex-col lg:flex-row"
            colorScheme="white"
            hideChatWithTutor
            hideVideoChatWithTutor
          />
        </div>
      )}
    </section>
  )
}
